import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogProps,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, { ComponentType, FC } from "react";
import { BackIcon } from "../icons";
import styled from "styled-components";

interface ModalProps {
  open: boolean;
  close: () => void;
  title?: string;
}

const Modal: FC<ModalProps> = ({ open, close, title = "", children }) => {
  return (
    <StyledDialog open={open} onClose={close}>
      <DialogTitle>
        <IconButton size="small" className="back-btn" onClick={close}>
          <BackIcon />
        </IconButton>
        <Typography>{title}</Typography>
        <IconButton className="close-btn" onClick={close}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
    </StyledDialog>
  );
};

export default Modal;

const StyledDialog = styled(Dialog)`
  .MuiDialog-container {
    align-items: stretch;
  }
  .MuiDialog-paper {
    width: 100%;
    max-width: 500px;
  }
  .MuiDialogTitle-root {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    padding: 6px 12px;
    .MuiTypography-root {
      font-size: 18px;
      font-weight: 700;
      color: var(--text-color-secondary);
    }
  }
  .MuiDialogContent-root {
    padding: 8px;
  }

  .back-btn {
    display: none;
  }
  @media (max-width: 480px) {
    .MuiPaper-root {
      margin: 0;
      max-height: 100%;
      border-radius: 0;
    }
    .MuiDialogTitle-root {
      justify-content: flex-start;
    }
    .MuiDialogTitle-root {
      padding: 8px;
    }
    .MuiTypography-root {
      font-size: 16px;
    }
    .back-btn {
      display: block;
      margin-right: 8px;
    }
    .close-btn {
      display: none;
    }
  }
  @media (min-width: 481px) {
    .MuiDialogContent-root {
      &::-webkit-scrollbar {
        width: 8px;
      }

      &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.15);
        border-radius: 10px;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 8px;
        -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.5);
      }
    }
  }
` as ComponentType<DialogProps>;
